import { Button, Modal, Stack, TextInput } from '@mantine/core'
import { useForm, zodResolver } from '@mantine/form'
import { z } from 'zod'

const urlSchema = z.object({
  url: z.string().url({ message: 'Please enter a valid URL (e.g., http://example.com)' }),
})

export interface ExtractFromWebsiteModalProps {
  opened: boolean
  onClose: () => void
  onSubmit: (values: { url: string }) => Promise<void>
  isExtracting: boolean
}

export function ExtractFromWebsiteModal({ opened, onClose, onSubmit, isExtracting }: ExtractFromWebsiteModalProps) {
  const form = useForm({
    initialValues: {
      url: '',
    },
    validate: zodResolver(urlSchema),
  })

  const handleSubmit = async (values: { url: string }) => {
    await onSubmit(values)
    // Optionally close modal on successful submit, or let parent handle it
    // form.reset(); // Reset form if keeping modal open
  }

  return (
    <Modal opened={opened} onClose={onClose} title="Extract Content from Website" centered>
      <form onSubmit={form.onSubmit(handleSubmit)}>
        <Stack>
          <TextInput
            withAsterisk
            label="Website URL"
            placeholder="https://example.com"
            {...form.getInputProps('url')}
          />
          <Button type="submit" loading={isExtracting}>
            Extract
          </Button>
        </Stack>
      </form>
    </Modal>
  )
}
